<template lang="html">
<b-navbar class="fixed-top" toggleable="md" type="dark" variant="info">
  <div class="text-center navbar-brand-wrapper d-flex align-items-top justify-content-center brand-logo">
    <a class="navbar-brand brand-logo" href="#">
      <img src="../../assets/images/dawn.png" />
      <span>SELLER</span> DAWN</a>
    <a class="navbar-brand brand-logo-mini" href="#">SD</a>
  </div>
  <div class="navbar-menu-wrapper d-flex align-items-center ml-auto ml-lg-0">
    <b-navbar-nav class="header-links d-none d-md-flex">
      
      <b-nav-item href="#" class="light-blue-bg"><i class="fa fa-truck" aria-hidden="true"></i> Orders for shipping: {{ finalShippingOrdersForApiCall.length }} </b-nav-item>
      <!-- Removed the floating vue component @click="toggleOrderCollection" -->
    </b-navbar-nav>
    <!-- Right aligned nav items -->
    <b-navbar-nav class="ml-auto">
      <!-- <b-nav-item-dropdown right class="preview-list">
          <template slot="button-content">
            <div class="count-indicator">
              <i class="icon mdi mdi-email-variant"></i>
              <span class="count">7</span>
            </div>
          </template>
          <b-dropdown-item class="preview-item" href="#">
            <p class="mb-0 font-weight-normal float-left">You have 4 new notifications
            </p>
            <span class="badge badge-pill badge-warning">View all</span>
          </b-dropdown-item>
          <b-dropdown-item class="preview-item" href="#">
            <div class="preview-thumbnail">
              <div class="preview-icon bg-success">
                <i class="mdi mdi-alert-circle-outline mx-0"></i>
              </div>
            </div>
            <div class="preview-item-content">
              <h6 class="preview-subject font-weight-medium">Application Error</h6>
              <p class="font-weight-light small-text">
                Just now
              </p>
            </div>
          </b-dropdown-item>
          <b-dropdown-item class="preview-item" href="#">
            <div class="preview-thumbnail">
              <div class="preview-icon bg-warning">
                <i class="mdi mdi-comment-text-outline mx-0"></i>
              </div>
            </div>
            <div class="preview-item-content">
              <h6 class="preview-subject font-weight-medium">Settings</h6>
              <p class="font-weight-light small-text">
                Private message
              </p>
            </div>
          </b-dropdown-item>
          <b-dropdown-item class="preview-item" href="#">
            <div class="preview-thumbnail">
              <div class="preview-icon bg-info">
                <i class="mdi mdi-email-outline mx-0"></i>
              </div>
            </div>
            <div class="preview-item-content">
              <h6 class="preview-subject font-weight-medium">New user registration</h6>
              <p class="font-weight-light small-text">
                2 days ago
              </p>
            </div>
          </b-dropdown-item>
        </b-nav-item-dropdown> -->
      <b-nav-item-dropdown right class="preview-list">
        <template slot="button-content">
          <div class="count-indicator">
            <i class="icon mdi mdi-bell-outline dark-txt"></i>
            <span class="count">0</span>
          </div>
        </template>
        <b-dropdown-item class="preview-item flex-wrap flex-sm-nowrap" href="#">
          <p class="mb-0 font-weight-normal float-left">You have 4 unread mails</p>
          <span class="badge badge-pill badge-warning">View all</span>
        </b-dropdown-item>
        <b-dropdown-item class="preview-item">
          <div class="preview-thumbnail">
            <img src="../../assets/images/faces/face10.jpg" alt="image" class="img-sm profile-pic">
          </div>
          <div class="preview-item-content flex-grow py-2">
            <p class="preview-subject ellipsis font-weight-medium text-dark">Marian Garner </p>
            <p class="font-weight-light small-text"> The meeting is cancelled </p>
          </div>
        </b-dropdown-item>
        <b-dropdown-item class="preview-item">
          <div class="preview-thumbnail">
            <img src="../../assets/images/faces/face12.jpg" alt="image" class="img-sm profile-pic">
          </div>
          <div class="preview-item-content flex-grow py-2">
            <p class="preview-subject ellipsis font-weight-medium text-dark">David Grey</p>
            <p class="font-weight-light small-text"> The meeting is cancelled </p>
          </div>
        </b-dropdown-item>
        <b-dropdown-item class="preview-item">
          <div class="preview-thumbnail">
            <img src="../../assets/images/faces/face1.jpg" alt="image" class="img-sm profile-pic">
          </div>
          <div class="preview-item-content flex-grow py-2">
            <p class="preview-subject ellipsis font-weight-medium text-dark">Travis Jenkins</p>
            <p class="font-weight-light small-text"> The meeting is cancelled </p>
          </div>
        </b-dropdown-item>
      </b-nav-item-dropdown>
      <b-nav-item-dropdown right class="preview-list">
        <template slot="button-content">
          <div class="user-identifier">
            {{ loggedInUser.username ? loggedInUser.username.substring(0, 1).toUpperCase() : "?" }}
          </div>
        </template>

        <b-dropdown-item href="#" @click.prevent="logOut" class="preview-item flex-wrap">Signout</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
    <button class="navbar-toggler navbar-toggler-right align-self-center" type="button" @click="collapedMobileSidebar()">
      <span class="mdi mdi-menu"></span>
    </button>
  </div>
</b-navbar>
</template>

<script lang="js">
import EventBus from '../../EventBus';
export default {
  name: 'app-header',
  methods: {
    collapedMobileSidebar: () => {
      document.querySelector('.sidebar').classList.toggle('active')
    },
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
    toggleOrderCollection() {
      EventBus.$emit('toggle-orders-collection');
    }
  },
  computed: {
    finalShippingOrdersForApiCall() {
      return this.$store.state.orders.ordersForShipping;
    },

    loggedInUser() {
      return this.$store.state.auth.user;
    },
   
    
  }
}
</script>

<style lang="scss" scoped>
a.brand-logo {

  color: rgb(255, 255, 255);

  &:hover,
  &:active,
  &:visited {
    color: rgb(255, 255, 255) !important;
  }

  span {
    color: #0DB3F8;
  }
}

.light-blue-bg {
  background-color: #eceef5;
  white-space: nowrap;

  a {
    color: #636a7c !important;
  }
}

img.bordered-image {
  border: 2px solid #fff;
}

.brand-logo {
  font-weight: bold;
}

.user-identifier {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #ff4b90;
  text-align: center;
  font-size: 20px;
  line-height: 40px;
}

.navbar-menu-wrapper {
  box-shadow: 1px 0 6px rgba(0, 0, 0, 0.1), 3px 0 14px rgba(0, 0, 0, 0.1);
}
</style>
